export type Login = {
    username: string
    password: string
}

export type UserSettings = {
    language: string,
    dateFormat: string,
    decimalSeparator: string
}

export type Profile = {
    userName: string
    mail: string
    cli: string
    firstName: string
    lastName: string
}

export type TokenProfile = {
    token: string
    profile: Profile
}

export type UserClaim = {
    claim: Claims
    scope: string[]
    scope2: string[]
}

export enum Claims {
    ActualStockSiteValidator = "ActualStockSiteValidator",
    ActualStockSiteReader = "ActualStockSiteReader",
    ActualStockSiteWriter = "ActualStockSiteWriter",
    StockManager = "StockManager",
    VesselWriter = "VesselWriter",
    VesselReader = "VesselReader",
    VesselManager = "VesselManager",
    VesselPurchaseDelegation = "VesselPurchaseDelegation",
    DealManager = "DealManager",
    DealReader = "DealReader",
    TruckManager = "TruckManager",
    TruckReader = "TruckReader",
    SalesManager = "SalesManager",
    SalesReader = "SalesReader",
    ChannelSalesManager = "ChannelSalesManager",
    FifoDashboardExport = "FifoDashboardExport",
    OverstayAgeingExport = "OverstayAgeingExport",
    MasterdataCompulsoryStockExport = "MasterdataCompulsoryStockExport",
    FeatureToggle = "FeatureToggle",
    Impersonate = "Impersonate",
    UserManager = "UserManager",
    Companies = "Companies",
    MasterdataStockCapacityReader = "MasterdataStockCapacityReader",
    MasterdataStockCapacityManager = "MasterdataStockCapacityManager",
    MasterdataPhysicalStockReader = "MasterdataPhysicalStockReader",
    MasterdataPhysicalStockManager = "MasterdataPhysicalStockManager",
    MasterdataProductCompanyWriter = "MasterdataProductCompanyWriter",
    MasterdataProductCompanyManager = "MasterdataProductCompanyManager",
    MasterdataPlantStorageLocationManager = "MasterdataPlantStorageLocationManager",
    MasterdataPlantStorageLocationWriter = "MasterdataPlantStorageLocationWriter",
    MasterdataPricingPeriodManager = "MasterdataPricingPeriodManager",
    MasterdataPlantManager = "MasterdataPlantManager",
    MasterdataCalendarManager = "MasterdataCalendarManager",
    MasterdataCalendarReader = "MasterdataCalendarReader",
    RefreshData = "RefreshData",
    MasterdataCounterpartyManager = "MasterdataCounterpartyManager",
    MasterdataCounterpartyReader = "MasterdataCounterpartyReader",
    MasterdataProductGroupCompulsoryStockLevel = "MasterdataProductGroupCompulsoryStockLevel",
    MasterdataLocalProduct = "MasterdataLocalProduct",
    MasterdataProductReader = "MasterdataProductReader",
    MasterdataProductWriter = "MasterdataProductWriter",
    MasterdataProductManager = "MasterdataProductManager",
    MasterDataProductRecipeManagement = "MasterDataProductRecipeManagement",
    MasterdataSapCounterpartyManager = "MasterdataSapCounterpartyManager",
    MasterdataSapCounterpartyReader = "MasterdataSapCounterpartyReader",
    MasterdataSapShipToManager = "MasterdataSapShipToManager",
    MasterdataSapShipToReader = "MasterdataSapShipToReader",
    MasterdataSupplyOriginManager = "MasterdataSupplyOriginManager",
    MasterdataSupplyOriginReader = "MasterdataSupplyOriginReader",
    MasterdataSupplyDestinationManager = "MasterdataSupplyDestinationManager",
    MasterdataSupplyDestinationWriter = "MasterdataSupplyDestinationWriter",
    MasterdataSupplyDestinationReader = "MasterdataSupplyDestinationReader",
    MasterdataCompulsoryStockLevel = "MasterdataCompulsoryStockLevel",
    MasterdataCustomerSegmentManager = "MasterdataCustomerSegmentManager",
    MasterdataCustomerSegmentProductManager = "MasterdataCustomerSegmentProductManager",
    DghStockExport = "DghStockExport",
    PersonaManager = "PersonaManager",
    UserPersonaManager = "UserPersonaManager",
    MasterDataVesselDelayManager = "MasterDataVesselDelayManager",
    MasterDataVesselDelayReader = "MasterDataVesselDelayReader",
    PxcReportExport = "PxcReportExport",
    IntegrityCheckReport = "IntegrityCheckReport",
    MarketRiskSimulatorManager = 'MarketRiskSimulatorManager',
    MarketRiskSimulatorReader = 'MarketRiskSimulatorReader',
    MasterdataCompanyManager = 'MasterdataCompanyManager',
    MasterdataCompanyReader = 'MasterdataCompanyReader',
    MasterdataRegulatedPriceManager = "MasterdataRegulatedPriceManager",
    MasterdataRegulatedPriceReader = "MasterdataRegulatedPriceReader",
    SupplyBalanceManager = "SupplyBalanceManager",
    SupplyBalanceReader = "SupplyBalanceReader",
    MasterdataSiteManager = 'MasterdataSiteManager',
    MasterdataSiteReader = 'MasterdataSiteReader',
    MasterdataCompanyDutyStatusManager = 'MasterdataCompanyDutyStatusManager',
    MasterdataCompanyDutyStatusReader = 'MasterdataCompanyDutyStatusReader',
    MasterdataJettyManager = "MasterdataJettyManager",
    MasterdataJettyReader = "MasterdataJettyReader",
    MasterdataJettyWriter = "MasterdataJettyWriter",
    MasterdataDealTypeManager = 'MasterdataDealTypeManager',
    MasterdataDealTypeReader = 'MasterdataDealTypeReader',
    MasterdataCommonReader = 'MasterdataCommonReader',
    MasterdataQuantityUnitPriceReader = 'MasterdataQuantityUnitPriceReader',
    MasterdataQuantityUnitPriceManager = 'MasterdataQuantityUnitPriceManager',
    MasterdataIncoTermReader = 'MasterdataIncoTermReader',
    MasterdataDealFieldsReader = 'MasterdataDealFieldsReader',
    TactixOutputReader = 'TactixOutputReader',
    ClearData = 'ClearData',
    ImportSamManager = "ImportSamManager",
    ImportPetrostockManager = "ImportPetrostockManager",
    MasterdataSupplyPlantAssignmentReader = 'MasterdataSupplyPlantAssignmentReader',
    MasterdataSupplyPlantAssignmentManager = 'MasterdataSupplyPlantAssignmentManager',
    MasterdataDealValidatorEmailReader = "MasterdataDealValidatorEmailReader",
    MasterdataPaymentTermReader = "MasterdataPaymentTermReader",
    MasterdataSapPurchaseOrganizationReader = "MasterdataSapPurchaseOrganizationReader",
    MasterdataValidationProcessReader = "MasterdataValidationProcessReader",
    MasterdataPriceIndexReader = "MasterdataPriceIndexReader",
    MasterdataPrimoMovementTypeReader = "MasterdataPrimoMovementTypeReader",
    MasterdataPrimoPricingAreaReader = "MasterdataPrimoPricingAreaReader",
    MasterdataPrimoPricingFormulaReader = "MasterdataPrimoPricingFormulaReader",
    MasterdataPrimoTranscoMotReader = "MasterdataPrimoTranscoMotReader",
    MasterdataPrimoTranscoProductReader = "MasterdataPrimoTranscoProductReader",
    MasterdataPrimoPriceIndexCodeReader = "MasterdataPrimoPriceIndexCodeReader",
    MasterdataProductSAPCodeReader = "MasterdataProductSAPCodeReader",
    MasterdataSapCustomerSegmentReader = "MasterdataSapCustomerSegmentReader",
    MasterdataSapDocumentTypeReader = "MasterdataSapDocumentTypeReader",
    MasterdataCustomerSegmentReader = "MasterdataCustomerSegmentReader",
    MasterdataCustomerSegmentProductReader = "MasterdataCustomerSegmentProductReader",
    MasterdataImportAradosReader = "MasterdataImportAradosReader",
    MasterdataMeanOfTransportationReader = "MasterdataMeanOfTransportationReader",
    MasterdataVesselFieldReader = "MasterdataVesselFieldReader",
    MasterdataSapCustomersReader = "MasterdataSapCustomersReader",
    MasterdataPublicPipeLineTranscoManager = "MasterdataPublicPipeLineTranscoManager",
    MasterdataPublicPipeLineTranscoDisplay = "MasterdataPublicPipeLineTranscoDisplay",
    MasterdataPublicPipeLineCalendarManager = "MasterdataPublicPipeLineCalendarManager",
    MasterdataPublicPipeLineCalendarDisplay = "MasterdataPublicPipeLineCalendarDisplay",
    MasterdataMovementMessagesRulesReader = "MasterdataMovementMessagesRulesReader",
    MasterdataUnusableStockPropagationPeriods = "MasterdataUnusableStockPropagationPeriods",
    MasterdataDocumentPathManager = "MasterdataDocumentPathManager",
    MasterdataDocumentPathReader = "MasterdataDocumentPathReader",
    RailCarsManager = "RailCarsManager",
    RailCarsReader = "RailCarsReader",
    MasterdataSapDealFieldPricingConditionsReader = "MasterdataSapDealFieldPricingConditionsReader",
    Diagnostics = "Diagnostics",
    MasterdataQuantityPriceUnitRulesReader = "MasterdataQuantityPriceUnitRulesReader",
    SupplyJournalReader = "SupplyJournalReader",
    MasterdataPetrostockReader = "MasterdataPetrostockReader",
    MasterdataGainsAndLossesCategoryReader = "MasterdataGainsAndLossesCategoryReader",
    MasterdataPriceIndexManager = "MasterdataPriceIndexManager",
    MasterdataDefaultPricingDensityReader = "MasterdataDefaultPricingDensityReader",
    MasterdataSupplyDealDefaultValueManager = "MasterdataSupplyDealDefaultValueManager",
    MasterdataSupplyDealDefaultValueReader = "MasterdataSupplyDealDefaultValueReader",
    MasterdataDasReader = "MasterdataDasReader",
    MasterdataMaxStockDaysReader = "MasterdataMaxStockDaysReader",
    MasterdataQuotationCalendarManager = "MasterdataQuotationCalendarManager",
    MasterdataPricingPeriodRuleReader = "MasterdataPricingPeriodRuleReader",
    MasterdataPricingPeriodRuleManager = "MasterdataPricingPeriodRuleManager",
    MasterdataRoadSalesProductManager = "MasterdataRoadSalesProductManager",
    MasterdataRoadSalesProductReader = "MasterdataRoadSalesProductReader",
    MasterdataVehicleManager = "MasterdataVehicleManager",
    MasterdataVehicleReader = "MasterdataVehicleReader",
}